export default __webpack_public_path__ + "static/apartment-with-kichen-67c48f491221da10d28bb5da1ed93d7a.jpg";